import { AbstractControl, AsyncValidatorFn, ValidationErrors } from '@angular/forms';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

// Todo: Bitte beachten Sie, dass dieser Validator wahr zurückgibt, wenn die E-Mail nicht die Beispiel-Domain enthält. In der Regel geben Validatoren wahr zurück, wenn ein Fehler auftritt, und nicht, wenn die Validierung erfolgreich ist. Sie möchten vielleicht überdenken, ob das die beabsichtigte Verwendung ist.
export function asyncEmailForBarmeniaDomainValidator(checkService: any): AsyncValidatorFn {
    return (control: AbstractControl): Promise<ValidationErrors | null> | Observable<ValidationErrors | null> => {
        const email = control.value;

        return checkService.checkEmailForBarmeniaDomain(email).pipe(
            map((result: any) => {
                if (!result.hasBarmeniaDomain) {
                    return { noBarmeniaDomain: true };
                } else {
                    return null;
                }
            }),
            catchError((err: Error) => {
                console.log(err);
                return of({
                    message: err.message,
                    messageType: 'error'
                });
            })
        );
    };
  }

export function asyncEmailValidator(checkService: any): AsyncValidatorFn {
    return (control: AbstractControl): Promise<ValidationErrors | null> | Observable<ValidationErrors | null> => {
        const email = control.value;

        return checkService.checkEmailApproval(email).pipe(
            map((result: any) => {
                if (result) {
                    return { emailApprovalFound: true };
                } else {
                    return null;
                }
            }),
            catchError((err: Error) => {
                console.log(err);
                return of({
                    message: err.message,
                    messageType: 'error'
                });
            })
        );
    };
}

export function asyncCheckEmailForAllowedDomain(checkService: any): AsyncValidatorFn {
    return (control: AbstractControl): Promise<ValidationErrors | null> | Observable<ValidationErrors | null> => {
        const email = control.value;

        return checkService.checkEmailForAllowedDomain(email).pipe(
            map((result: any) => {
                if (!result.hasAllowedDomain) {
                    return { noAllowedDomain: true };
                } else {
                    return null;
                }
            }),
            catchError((err: Error) => {
                console.log(err);
                return of({
                    message: err.message,
                    messageType: 'error'
                });
            })
        );
    };
}

// Todo: Originalcode ggf. löschen
// private checkEmailForBarmeniaDomain(control: FormControl): any {
//   this.isValidatingEmail = true;
//   const email = control.value;
    
//   return this.checkService.checkEmailForBarmeniaDomain(email).pipe(
//     map(
//       result => {
//         this.isValidatingEmail = false;
//         if (!result.hasBarmeniaDomain) {
//           return { noBarmeniaDomain: true };
//         }
//         return null;
//       },
//       (err: Error) => {
//         console.log(err);
//         this.isValidatingEmail = false;
//       }
//     )
//   );
// }